import React from "react";
import { IQuickSearchBtn } from "../@types";
import TooltipButton from "../TooltipButton";
import useKeyboardShortcut from "../../../../components/hooks/useKeyboardShortcut";
import { SEARCH_MODALS_NAMES } from "../../../search/hooks/useSearchModals";

const QuickSearchQueryBtn = (props: IQuickSearchBtn) => {
  useKeyboardShortcut("q", { altKey: true }, () =>
    props.onClick({ type: SEARCH_MODALS_NAMES.QUICK_SEARCH })
  );
  return (
    <TooltipButton
      onClick={() => props.onClick({ type: SEARCH_MODALS_NAMES.QUICK_SEARCH })}
      label="Quick search [Alt+Q]"
      type="quick-search"
    />
  );
};

export default QuickSearchQueryBtn;
